import type {ReactAction} from '@netx/core/bootstrap';
import {faClipboardList} from '@netx/core-icons';
import {canReviewCurrentCart} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

/**
 * Review cart assets
 * @param params
 * @returns Action
 */
export const cartActionReview = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-current-review',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.REVIEW),
	enableTest: canReviewCurrentCart,
	icon: faClipboardList,
	get label() {
		return CART_CURRENT_ACTION_LABELS.REVIEW;
	},
	...params,
});

export default cartActionReview;
